export const PRAYER_TIMES = {
  SUBUH: 'subuh',
  TERBIT: 'terbit',
  DZUHUR: 'dzuhur',
  ASHAR: 'ashar',
  MAGHRIB: 'maghrib',
  ISYA: 'isya',
};

export const PRAYER_NAMES = {
  [PRAYER_TIMES.SUBUH]: 'Subuh',
  [PRAYER_TIMES.TERBIT]: 'Syuruq',
  [PRAYER_TIMES.DZUHUR]: 'Dzuhur',
  [PRAYER_TIMES.ASHAR]: 'Ashar',
  [PRAYER_TIMES.MAGHRIB]: 'Maghrib',
  [PRAYER_TIMES.ISYA]: 'Isya',
};

export const PRAYER_ORDER = [
  PRAYER_TIMES.SUBUH,
  PRAYER_TIMES.TERBIT,
  PRAYER_TIMES.DZUHUR,
  PRAYER_TIMES.ASHAR,
  PRAYER_TIMES.MAGHRIB,
  PRAYER_TIMES.ISYA,
];

export const TIMING_STATES = {
  ADZAN: 0,
  COUNTDOWN_3: 3,
  COUNTDOWN_4_9: '4-9',
  IQOMAH: 10,
  SHOLAT: 0,
  RESET: 18,
};

export const IQOMAH_COUNTDOWN = 7;

export const MASJID_INFO = {
  name: 'MASJID AL - MUHAJIRIN',
  location: 'Cluster Jasmine - Grand Depok City',
  city: 'Kota Depok - Jawa Barat',
  website: 'www.jws.4netps.co.id/almuhajirin',
};

export const COLORS = {
  primary: '#006783',
  secondary: '#FFB703',
  background: 'rgba(30, 30, 30, 0.75)',
  backgroundDark: 'rgba(30, 30, 30, 0.90)',
  white: '#FFFFFF',
  text: '#FFFFFF',
};

